import { createContext } from "react";
import { ThemeType } from "../enums/theme-type.enum";

// export const ThemeContext = createContext(null);
export const ThemeContext = createContext({ theme: ThemeType.DARK, changeTheme: () => {}});
// export const ThemeContext = createContext<{ theme: ThemeType, changeTheme: () => void} | null>(null);
